import React from 'react';
import { NavLink } from 'react-router-dom';
import routes from '../../../../routes';
import Dropdown from '../../Dropdown';

const Title = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.51045 0.799988L9.37285 1.49872L8.84646 4.05546C8.00486 4.37685 7.24165 4.83259 6.55205 5.37303L3.97925 4.51278L3.28806 4.29852L2.92966 4.91571L1.15845 7.87694L0.800049 8.49423L1.32485 8.95311L3.31526 10.6464C3.24326 11.0893 3.15046 11.5274 3.15046 11.9927C3.15046 12.458 3.24326 12.8961 3.31526 13.3391L1.32485 15.0323L0.800049 15.4912L1.15845 16.1084L2.92966 19.0697L3.28806 19.6885L3.97925 19.4726L6.55205 18.6124C7.24165 19.1528 8.00486 19.6085 8.84646 19.9299L9.37285 22.4866L9.51045 23.1854H14.4881L14.6272 22.4866L15.1521 19.9299C15.9937 19.6085 16.7569 19.1528 17.4465 18.6124L20.0193 19.4726L20.7104 19.6885L21.0705 19.0697L22.8401 16.1084L23.2 15.4912L22.6737 15.0323L20.6833 13.3391C20.7569 12.8961 20.848 12.458 20.848 11.9927C20.848 11.5274 20.7569 11.0893 20.6833 10.6464L22.6737 8.95311L23.2 8.49423L22.8401 7.87694L21.0705 4.91571L20.7104 4.29852L20.0193 4.51278L17.4465 5.37303C16.7569 4.83259 15.9937 4.37685 15.1521 4.05546L14.6272 1.49872L14.4881 0.799988H9.51045Z"
      stroke="#424242"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1995 11.9927C15.1995 13.7579 13.7659 15.1906 11.9995 15.1906C10.2331 15.1906 8.79946 13.7579 8.79946 11.9927C8.79946 10.2274 10.2331 8.79481 11.9995 8.79481C13.7659 8.79481 15.1995 10.2274 15.1995 11.9927Z"
      stroke="#424242"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);

const SelectSettings = () => {
  return (
    <div style={{ margin: '0 10px' }}>
      <Dropdown title={<Title />} position="left" leave>
        <ul className="dash-nav__list">
          <li>
            <NavLink
              to={routes.Settings.Security.path}
              activeClassName="drop-option active"
              className="drop-option"
            >
              <i className="fa fa-credit-card" />
              <span className="drop-title drop-title-name">Security</span>
            </NavLink>
          </li>
          {/* <li>
            <NavLink
              to={routes.Settings.BankAccounts.path}
              activeClassName="drop-option active"
              className="drop-option"
            >
              <i className="fa fa-th" />
              <span className="drop-title drop-title-name">Bank accounts</span>
            </NavLink>
          </li> */}
        </ul>
      </Dropdown>
    </div>
  );
};

export default SelectSettings;
